import { i18n } from 'i18next';

export function loadTranslations(i18nInstance: i18n, namespaces: string[]): Record<string, string> {
  const dataByLanguage = i18nInstance.getDataByLanguage(i18nInstance.language)!;
  let messages = {};
  namespaces.forEach(namespace => {
    messages = { ...messages, ...(dataByLanguage as any)[namespace] };
  });
  return messages;
}
